import axios from 'axios';
import { VerifyAuth } from './axiosInterceptor';

const API = process.env.REACT_APP_API_PATH;

export const getUserbyUsername = async (userName, token) => {
  try {
    return await axios
      .get(`${API}/getUserByUsername`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
        params: {
          userName
        }
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const getUserbyUserId = async (userId,token) => {
  try {

    return await axios
      .get(`${API}/getUserbyUserId/${userId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization":`Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const getUsers = async (token, userName = '') => {
  try {
    if (!token) {
      console.error('No token provided to getUsers');
      return { error: 'Authentication token is missing' };
    }
    
    const params = {};
    if (userName) params.userName = userName;
    
    return await axios
      .get(`${API}/getUsers`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
        params
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.error('Error fetching users:', err.response?.data || err.message);
        return err.response;
      });
  } catch (err) {
    console.error('Exception in getUsers:', err.message);
    return { error: err.message };
  }
};


export const addUser = async (data,token) => {
  try {

    return await axios
      .post(`${API}/addUser`, data, {
        headers: {
          'Content-Type': 'application/json',
          "authorization":`Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const deleteUser = async (userRegId,token) => {
  try {

    return await axios
      .delete(`${API}/deleteUser/${userRegId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization":`Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const deleteCompany = async (companyMasterId, token) => {
  try {
    return await axios
      .delete(`${API}/deleteCompany/${companyMasterId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        // If err.response exists, but err.response.data is a string, wrap it in an object
        if (err.response && typeof err.response.data === 'string') {
          err.response.data = { error: err.response.data };
        }
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

export const deleteCompanyByMasterId = async (companyMasterId, token) => {
  try {
    return await axios
      .delete(`${API}/deleteCompanyByMasterId/${companyMasterId}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization": `Bearer ${token}`
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        if (err.response && typeof err.response.data === 'string') {
          err.response.data = { error: err.response.data };
        }
        return err.response;
      });
  } catch (err) {
    return err;
  }
};



export const getUserForPrivateMessages = async (label,token) => {
  try {

    return await axios
      .get(`${API}/getUserForPrivateMessages/${label}`, {
        headers: {
          'Content-Type': 'application/json',
          "authorization":`Bearer ${token}`
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
  } catch (err) {
    return err;
  }
};

